import { render, staticRenderFns } from "./VlDeadlineFilter.vue?vue&type=template&id=d38f5404&scoped=true&"
import script from "./VlDeadlineFilter.vue?vue&type=script&lang=js&"
export * from "./VlDeadlineFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38f5404",
  null
  
)

export default component.exports